import { render, staticRenderFns } from "./ConsultantProcessing.vue?vue&type=template&id=27f53679&"
import script from "./ConsultantProcessing.vue?vue&type=script&lang=js&"
export * from "./ConsultantProcessing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports